<h5 class="header">
  {{'ISSUE-TEXT.BUYER-DETAILS' | translate}}
</h5>
<div class="box-content">
  <div [formGroup]="buyerForm" style="margin-bottom: -1rem;">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-name">{{'ISSUE-TEXT.BUYER-NAME'|translate}}</label>
          </div>
          <div class="col-md-8">
            <ng-select class="custom" [items]="buyers" [addTag]="true" labelForId="buyer-name" bindLabel="name"
              bindValue="name" placeholder="{{'FILTER.PLACEHOLDER' | translate}}" [addTagText]="'NORMAL.ADD'|translate"
              [clearable]="false" formControlName="name" (change)="setBuyer($event)">
            </ng-select>
            <div *ngIf="buyerName.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-tax-id">{{ 'ISSUE-TEXT.TAX-ID'|translate }}</label>
          </div>
          <div class="col-md-8">
            <ng-select class="custom"
                [items]="buyers"
                [addTag]="true"
                labelForId="buyer-tax-id"
                bindLabel="tax_id"
                bindValue="tax_id"
                placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
                [addTagText]="'NORMAL.ADD'|translate"
                [clearable]="false"
                formControlName="taxID"
                (change)="setBuyer($event)">
            </ng-select>
            <div *ngIf="buyerTaxID.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
            <div *ngIf="buyerTaxID.errors?.taxIDInvalid && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.INVALID' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-branch-code">{{'TABLE.BRANCH-CODE'|translate}}</label>
          </div>
          <div class="col-md-8">
            <div class="row align-items-center">
              <div class="col">
                <ng-select class="custom" [items]="buyerBranches.length ? buyerBranches : []" [addTag]="true"
                  labelForId="buyer-branch-code" bindLabel="branch_code" bindValue="branch_code"
                  placeholder="{{'FILTER.PLACEHOLDER' | translate}}" [addTagText]="'NORMAL.ADD'|translate"
                  formControlName="branchCode" (change)="setBuyerBranch($event)">
                </ng-select>
              </div>
              <div class="col-auto text-nowrap">
                <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="isBuyerHeadOffice"
                  (onChange)="setBuyerHeadOffice()" [ngModelOptions]="{standalone: true}"
                  label="{{'DATA.HEAD-OFFICE'|translate}}">
                </p-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-branch-name">{{'TABLE.BRANCH-NAME'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="buyer-branch-name" formControlName="branchName">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-address">{{'FILTER.ADDRESS'|translate}}</label>
          </div>
          <div class="col-md-8">
            <textarea class="form-control" id="buyer-address" rows="3" formControlName="address"></textarea>
            <div *ngIf="buyerAddress.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-postal-code">{{'DATA.DELIVERY-POSTALCODE'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="buyer-postal-code" formControlName="postalCode">
            <div *ngIf="buyerPostalCode.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
            <div *ngIf="buyerPostalCode.errors?.postalCodeInvalid && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.INVALID' | translate }}</span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-country">{{'DATA.COUNTRY'|translate}}</label>
          </div>
          <div class="col-md-8">
            <ng-select class="custom"
                [items]="countries"
                labelForId="buyer-country"
                [bindLabel]="currentLang === 'en' ? 'country_name' : 'country_name_th'"
                bindValue="country_code"
                placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
                [clearable]="false"
                formControlName="country"
                *ngIf="!refreshDropdown">
            </ng-select>
            <div *ngIf="buyerCountry.errors?.required && isSubmitted">
              <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-email">{{'EMAIL-DASHBOARD.EMAIL'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="buyer-email" formControlName="email">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <div class="col-md-4">
            <label for="buyer-cc-email">{{'EMAIL-DASHBOARD.CC-EMAIL'|translate}}</label>
          </div>
          <div class="col-md-8">
            <input class="form-control" type="text" id="buyer-cc-email" formControlName="ccEmail">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/buyer-form/buyer-form.component.html